import { COUNTRY } from './country.token';

export const provideCountry = (preferredCountryIds: string[] = []) => ({
    provide: COUNTRY,
    useValue: {
        preferredCountryIds: preferredCountryIds,
    },
});
